export const ypoMapConstant = {
    YPO_Integrated_Chapter: 'YPO Integrated Chapter',
    mapIcons: [
        {
            key: 'YPO Integrated Chapter',
            value: {
                url: 'https://res.cloudinary.com/ypoconnect-prod/image/upload/f_auto,q_auto/chapterpins/Pin_5.png',
                scaledSize: {
                    width: 22,
                    height: 30,
                    f: 'px',
                    b: 'px',
                },
            },
        },
        {
            key: 'YPO Gold Chapter',
            value: {
                url: 'https://res.cloudinary.com/ypoconnect-prod/image/upload/f_auto,q_auto/chapterpins/Pin_4.png',
                scaledSize: {
                    width: 22,
                    height: 30,
                    f: 'px',
                    b: 'px',
                },
            },
        },
        {
            key: 'YPO Chapter',
            value: {
                url: 'https://res.cloudinary.com/ypoconnect-prod/image/upload/f_auto,q_auto/chapterpins/Pin_3.png',
                scaledSize: {
                    width: 22,
                    height: 30,
                    f: 'px',
                    b: 'px',
                },
            },
        },
    ],
};
